import { ADD_PERMISSION, ALL_PERMISSION, EDIT_PERMISSION, GET_PERMISSION } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  data: null,
}

const Permission = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PERMISSION:
    case GET_PERMISSION:
      state = {
        ...state,
        loading: true,
      }
      break
    case ALL_PERMISSION:
      state = {
        ...state,
        loading: false,
        data: action.payload.data,
      }
      break
    case EDIT_PERMISSION:
      state = {
        ...state,
        loading: false,
      }
      break
    default:
      break
  }
  return state
}

export default Permission
